import { Component } from '@angular/core';
import { Policies } from '@app/auth/auth-policies';

@Component({
  selector: 'app-catalogue',
  templateUrl: './catalogue.component.html',
  styleUrls: ['./catalogue.component.less'],
})
export class CatalogueComponent {
  developerPolicy = Policies.developer;
  constructor() {}
}
